import CSCompensationFAB from "@components/features/CSCompensation/CSCompensationFAB/CSCompensationFAB";
import { PropsWithClassName, cn } from "kz-ui-sdk";

interface CSCompensationProps extends PropsWithClassName {
  fabClassName?: string;
  onClick?: () => void;
}

const CSCompensation = ({ className, fabClassName, onClick }: CSCompensationProps) => {
  return (
    <div className={cn(className)}>
      <CSCompensationFAB
        className={cn(fabClassName)}
        zIndex={20}
        aria-label="CS Compensation FAB"
        onClick={onClick}
      />
    </div>
  );
};

export default CSCompensation;
